export default "__VITE_ASSET__BslhVM2P__"